import React, { useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from './UserContext';
import './DemoForfait.css';
import { useTranslation } from './LanguageContext';
import { getDemoVideoUrl } from '../utils/demoVideo';

/**
 * Section unifiée Démo + Forfait (style aligné à Demo.png)
 * - Vidéo large centrée avec overlay Play
 * - Carte d'offre centrée en dessous
 */
export default function DemoForfait() {
  const navigate = useNavigate();
  const { user } = useUser();
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const { t } = useTranslation();

  const src = useMemo(() => getDemoVideoUrl(), []);

  const handleChoose = (plan) => {
    if (user) {
      // requett de verification de l'abonement de l'utilisateur
      navigate(`/payment?plan=${plan}`);
    } else {
      navigate('/login', { state: { from: `/payment?plan=${plan}` } });
    }
  };

  return (
    <section className="demo-pricing-section" aria-label={t('demo.aria')}>
      {/* Ancre secondaire pour compat nav legacy */}
      <span id="forfait" />
      <div className="container">
        <div className="section-title">
          <h2>{t('demo.title')}</h2>
        </div>

        {/* Vidéo centrée avec overlay */}
        <div className="dp-hero">
          <div className="dp-video">
            <video
              ref={videoRef}
              src={src}
              controls
              playsInline
              preload="metadata"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />
            {!isPlaying && (
              <div className="dp-overlay">
                <button
                  type="button"
                  aria-label={t('demo.play')}
                  className="dp-play-btn"
                  onClick={() => videoRef.current?.play()}
                />
              </div>
            )}
          </div>
          
        </div>

        {/* Carte d'offre */}
        <div className="dp-offer-card">
          <h3 className="dp-offer-title">
            <span className="offre">{t('demo.offer.badge1')}</span><br />
            <span className="payant">{t('demo.offer.badge2')}</span>
          </h3>
          <p className="dp-desc">{t('demo.desc')}</p>
          <ul className="dp-benefits">
            <li>{t('demo.b1')}</li>
            <li>{t('demo.b2')}</li>
            <li>{t('demo.b3')}</li>
          </ul>
          <button type="button" className="btn" onClick={() => handleChoose('standard')}>{t('demo.cta')}</button>
        </div>
      </div>
    </section>
  );
}
